<template>
  <div class="receiving-order-item">
    <div class="con df-c-b">
      <div class="con-left df-c">
        <div class="number" :class="index>=4?'number-4':''">{{index}}</div>
         <div class="client" :class="index>=4?'client-4':''">{{item.client}}</div>
        <div class="name" :class="index>=4?'name-4':''">{{item.name}}</div>
      </div>
      <div class="con-right df-c">
        <span class="value" :class="index>=4?'value-4':''">{{item.value}}</span>
        <span class="unit">款</span>
      </div>
    </div>
    <div class="progress">
      <div
        class="progress-value"
        :class="index>=4?'progress-value-4':''"
        :style="{width:(item.value/maxNumber*100).toFixed(1)+'%'}"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReceivingOrderItem',
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    index: {
      type: Number,
      default: 1
    },
    maxNumber: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      dept: ''
    }
  },
  components: {},
  watch: {},
  created () {
    this.dept = this.$cookies.get('bsmdept')
  },
  methods: {}
}
</script>

<style scoped lang="less">
.con {
  margin-bottom: 12px;
  .client {
    margin-left: 8px;
    height: 24px;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    color: #ffd15c;
    flex: none;
    order: 0;
    flex-grow: 0;
  }
  .client-4 {
    color: #07d1fa;
  }
  .name {
    margin-left: 8px;
    padding: 1px 6px;
    border-radius: 2px;
    border: 1px solid #ffd15c;
    height: 20px;
    font-family: 'Source Han Sans CN';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #ffd15c;
  }
  .name-4 {
    color: #07d1fa;
    border: 1px solid #07d1fa;
  }
  .value {
    height: 24px;
    font-family: 'D-DIN';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #ffd15c;
    margin-right: 4px;
    margin-left: 8px;
  }
  .value-4 {
    color: #07d1fa;
  }
  .unit {
    height: 18px;
    font-family: 'D-DIN';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #c6d1db;
  }
  .con-left {
    .number {
      width: 20px;
      height: 24px;
      background-image: url('../assets/images/bigscreenSales/no.png');
      background-size: 100% 100%;
      font-size: 16px;
      line-height: 24px;
      text-align: center;
      color: #fff;
    }
    .number-4 {
      background-image: url('../assets/images/bigscreenSales/no4.png');
    }
  }

  .con-right {
  }
}

.progress {
  width: 100%;
  height: 4px;
  background: rgba(208, 222, 238, 0.1);
  margin-bottom: 12px;
  position: relative;
  .progress-value {
    position: absolute;
    top: 0;
    left: 0;
    height: 4px;
    background: linear-gradient(
      270deg,
      #ffd15c 1.64%,
      rgba(200, 172, 36, 0.4) 100%
    );
    &::after {
      position: absolute;
      content: '';
      right: 0;
      top: -2px;
      width: 8px;
      height: 8px;
      background: #ffffff;
      box-shadow: 0px 0px 4px #efd48e;
      border-radius: 4px;
    }
  }
  .progress-value-4 {
    background: linear-gradient(
      270deg,
      #5ce4ff 1.64%,
      rgba(36, 145, 200, 0.4) 100%
    );
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReceivingOrderItem.vue